module.exports = __webpack_public_path__ + "media/assets/images/category/Love@2x-e95eaf5c9a8998eba8410f0ba58e1f31.png";